import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Clock, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { APPOINTMENT_TYPE_LABELS, TIME_SLOT_LABELS } from "@/data/appointments";
import { EmptyState } from "@/components/portal/PortalBits";

const statusCls = {
  scheduled: "text-primary-brand",
  completed: "text-emerald-600",
  cancelled: "text-slate-400 line-through",
};

export function AppointmentsList() {
  const [appts, setAppts] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/client/appointments");
        setAppts(data);
      } catch (error) {
        console.error("Appointments load failed:", error);
        setAppts([]);
      }
    })();
  }, []);

  return (
    <div data-testid="my-appointments-panel" className="space-y-4">
      <div className="flex justify-end">
        <Link
          to="/book"
          data-testid="portal-book-appointment"
          className="inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] text-white px-5 py-2.5 font-bold uppercase tracking-wider text-xs"
        >
          <Plus className="h-4 w-4" /> Book Appointment
        </Link>
      </div>
      {appts === null ? (
        <div className="text-center text-sm text-slate-500 py-10">Loading…</div>
      ) : appts.length === 0 ? (
        <EmptyState label="No appointments yet. Book your first one above." />
      ) : (
        <div className="border border-slate-200 bg-white divide-y divide-slate-100">
          {appts.map((a) => (
            <div key={a.id} data-testid={`my-appointment-${a.id}`} className="p-5 flex flex-col md:flex-row md:items-center gap-3">
              <div className="flex items-center gap-3 w-56 flex-none">
                <CalendarDays className="h-5 w-5 text-primary-brand" />
                <div>
                  <div className="font-heading font-bold text-slate-900">{a.date}</div>
                  <div className="text-xs text-slate-500 flex items-center gap-1">
                    <Clock className="h-3 w-3" /> {TIME_SLOT_LABELS[a.time_slot] || a.time_slot}
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="text-sm font-bold text-slate-900">{APPOINTMENT_TYPE_LABELS[a.appointment_type] || a.appointment_type}</div>
                {a.reference && <div className="text-xs text-slate-500">Ref: {a.reference}</div>}
                {a.notes && <div className="text-xs text-slate-600 mt-0.5">{a.notes}</div>}
              </div>
              <span className={`text-xs uppercase tracking-[0.2em] font-bold flex-none ${statusCls[a.status] || "text-slate-600"}`}>
                {a.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
